import { EditorOpenGraphDto } from '@diritto/common/editor/dtos/editor-open-graph.dto';
import { Http } from '@diritto/common/utils/requester/http';

export class EditorApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getOpengraph(url: string): Promise<EditorOpenGraphDto> {
    const res = await this.http.get<EditorOpenGraphDto>(`${this.url}/editor/parse/opengraph`, {
      params: { url },
    });
    return res.data;
  }
}
